import React, { useContext } from "react";
import { FormControl } from "@mui/material";
import { IsEngineerRequired } from "../../../Utils/UtilityMethods";

import { HasValue } from "../../../sharedCode/HelperMethods";
import StringEditor from "../../../Components/inputs/stringEditor";
import DetailPage from "../../../Components/navigation/detailPage";
import { doNothing } from "../../../Components/inputs/inputHelpers";
import { TicketProps } from "../FlightLegs/ticketFlightLegs";
import { findById } from "../../../Utils/ContextLookups";
import PilotSelector from "../../../Components/inputs/selects/pilotSelector";
import { GlobalContext } from "../../../Utils/Contexts";
import AmeSelector from "../../../Components/inputs/selects/ameSelector";
import AircraftSelector from "../../../Components/inputs/selects/aircraftSelector";
import { YesNoControl } from "../../../Components/YesNoControl";
import BaseLocationSelector from "../../../Components/inputs/selects/baseLocationSelector";
import { saveTicketChanges } from "../../../Utils/TicketDatabase";
import { FIELD_LIMITS } from "../../../sharedCode/fieldLimits";

export function TicketCrew(props: TicketProps): JSX.Element {
    const context = useContext(GlobalContext);
    const aircraft = findById(props.aircraftList, props.ticket.aircraft_id);

    return (
        <DetailPage>
            <FormControl fullWidth>
                <PilotSelector
                    sourceId={props.ticket.id}
                    sourceProperty="pilot_person_id"
                    labelText="PILOT"
                    isRequired={true}
                    initialValue={props.ticket.pilot_person_id}
                    mergeChanges={(ticketId, values) => {
                        saveTicketChanges(ticketId, values).catch(() => props.showForceReloadDialogue());
                    }}
                    isDisabled={props.isReadOnly}
                    errors={props.errors}
                    containerUrl={"ticket/crew"}
                />
                <PilotSelector
                    sourceId={props.ticket.id}
                    sourceProperty="pilot_person_id2"
                    labelText="SECOND PILOT"
                    isRequired={false}
                    initialValue={props.ticket.pilot_person_id2}
                    mergeChanges={(ticketId, values) => {
                        saveTicketChanges(ticketId, values).catch(() => props.showForceReloadDialogue());
                    }}
                    isDisabled={props.isReadOnly}
                    errors={props.errors}
                    containerUrl={"ticket/crew"}
                />
                <AmeSelector
                    sourceId={props.ticket.id}
                    mergeChanges={(ticketId, values) => {
                        saveTicketChanges(ticketId, values).catch(() => props.showForceReloadDialogue());
                    }}
                    sourceProperty="ame_person_id"
                    labelText="ENGINEER"
                    isRequired={IsEngineerRequired(aircraft)}
                    initialValue={props.ticket.ame_person_id}
                    isDisabled={props.isReadOnly}
                    errors={props.errors}
                    containerUrl={"ticket/crew"}
                />
                <AircraftSelector
                    sourceId={props.ticket.id}
                    mergeChanges={(ticketId, values) => {
                        saveTicketChanges(ticketId, values).catch(() => props.showForceReloadDialogue());
                    }}
                    sourceProperty="aircraft_id"
                    labelText="AIRCRAFT"
                    isRequired={true}
                    initialValue={props.ticket.aircraft_id}
                    isDisabled={props.isReadOnly}
                    errors={props.errors}
                    containerUrl={"ticket/crew"}
                />
                <YesNoControl
                    sourceId={props.ticket.id}
                    sourceProperty={"is_aircraft_substituted"}
                    labelText="AIRCRAFT SUBSTITUTED?"
                    initialValue={HasValue(props.ticket.is_aircraft_substituted) ? Boolean(props.ticket.is_aircraft_substituted) : null}
                    onChange={doNothing}
                    mergeChanges={(ticketId, values) => {
                        saveTicketChanges(ticketId, values).catch(() => props.showForceReloadDialogue());
                    }}
                    isDisabled={props.isReadOnly}
                    isRequired={true}
                    errors={props.errors}
                    containerUrl={"ticket/crew"}
                />
                <AircraftSelector
                    sourceId={props.ticket.id}
                    mergeChanges={(ticketId, values) => {
                        saveTicketChanges(ticketId, values).catch(() => props.showForceReloadDialogue());
                    }}
                    isDisabled={props.isReadOnly || !props.ticket.is_aircraft_substituted}
                    sourceProperty="substituted_aircraft_id"
                    labelText="SUBSTITUTED AIRCRAFT"
                    isRequired={props.ticket.is_aircraft_substituted === 1}
                    initialValue={props.ticket.substituted_aircraft_id}
                    errors={props.errors}
                    containerUrl={"ticket/crew"}
                />
                <BaseLocationSelector
                    sourceId={props.ticket.id}
                    mergeChanges={(ticketId, values) => {
                        saveTicketChanges(ticketId, values).catch(() => props.showForceReloadDialogue());
                    }}
                    sourceProperty="airport_code"
                    labelText="BASE LOCATION"
                    isRequired={true}
                    initialValue={props.ticket.airport_code}
                    isDisabled={props.isReadOnly}
                    errors={props.errors}
                    containerUrl={"ticket/crew"}
                />
                <StringEditor
                    labelText="JOB LOCATION"
                    initialValue={props.ticket.job_location}
                    sourceId={props.ticket.id}
                    sourceProperty={"job_location"}
                    isRequired={false}
                    mergeChanges={(ticketId, values) => {
                        saveTicketChanges(ticketId, values).catch(() => props.showForceReloadDialogue());
                    }}
                    isDisabled={props.isReadOnly}
                    errors={props.errors}
                    containerUrl={"ticket/crew"}
                    maxLength={FIELD_LIMITS.job_location}
                />
            </FormControl>
        </DetailPage>
    );
}
